import { localStorageService } from './localStorage';
import type { DeviceSession } from '../types/device';

// One pass per device, so a person can hold passes for more than one wall at a
// time without them overwriting each other.
const keyFor = (code: string) => `device_session_${code}`;

/**
 * Where a device usage pass lives on the client. The pass is handed the
 * localStorage service's own expiry, so it drops out of storage exactly when it
 * lapses server-side and `get` returns null from then on.
 */
export const deviceSessionStore = {
  save(code: string, session: DeviceSession): void {
    localStorageService.set(keyFor(code), session, session.expires_in * 1000);
  },

  get(code: string): DeviceSession | null {
    return localStorageService.get<DeviceSession>(keyFor(code));
  },

  clear(code: string): void {
    localStorageService.remove(keyFor(code));
  },
};
